import { useParams } from 'react-router-dom'


export const Score = () => {
    const { score } = useParams()
        return (
            <div className='container random-bg position-relative'>
                <p className='position-absolute score-holder'>You finished with the score:{score}</p>
            </div>
        )
    }
    
    
export default Score;